let _env = {};
async function tryFetch(url) {
    try {
        const res = await fetch(url);
        if (res.ok)
            return (await res.json());
    }
    catch {
    }
    return null;
}
export async function loadEnvironment() {
    _env = (await tryFetch('/environment.local.json')) ?? (await tryFetch('/environment.json')) ?? {};
}
export function getEnv(key) {
    return _env[key] ?? '';
}
